export default "__VITE_ASSET__3l3Td_RQ__"